import React from "react";
import { connect } from "react-redux";
import { Button, Modal, Form, message,Input } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicImport from "../../components/frame/DynamicImport";
import DynamicButton from "../../components/frame/DynamicButton";
import DynamicFilter from "../../components/frame/DynamicFilter";
import ReduxAbstract from "../../components/abstract/Redux.abstract";
import {
	fetchEmployeesList
} from '../../actions/employee-management-actions';
import {
	fetchDepartmentsList
} from '../../actions/department-structure-actions';
import {
	changeSalaryManagement,
	selectSalaryManagement,
	updateSalaryManagement,
} from "../../actions/salary-allowance-actions";
import salaryManagementService
from "../../services/SalaryAllowance/salary-management-service";
import commonService from '../../services/Common/common-service';

const { Search } = Input


class SalaryManagement extends ReduxAbstract {

	initReload = true
	moduleName = "salaryAllowance"
	childModuleName = "salaryManagement"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		importModalStatus: false,
		recordModalStatus: false,
		passwordModalStatus:true,
		recordIndex: null,
		recordData: [],
		recordDataStatus: "unload",
		action:'',
        time:59,
        loading:false
	}

	actions = {
		changeAction: this.props.changeSalaryManagement,
		selectAction: this.props.selectSalaryManagement,
		updateAction: this.props.updateSalaryManagement,

		deleteAction: salaryManagementService.deleteSalaryManagement,
		createAction: salaryManagementService.createSalaryManagement,
		importAction: salaryManagementService.importSalaryManagement,
		exportAction: salaryManagementService.exportSalaryManagement,
		downloadTemplateAction: salaryManagementService.downloadSalaryManagementTemplate
	}

	headerColumn = [{
			title: "新增",
			icon: "plus-circle-o",
			access: "c_value",
			click: () => this.createData()
		}, {
			title: "批量删除",
			icon: "delete",
			access: "d_value",
			click: this.publicDelete
		}, {
			title: "导入",
			icon: "cloud-upload-o",
			access: "import_value",
			click: () => this.setState({importModalStatus: true})
		}, {
			title: "导出",
			icon: "cloud-download-o",
			access: "export_value",
			click: this.publicExport
		}
	]

	filterColumn = [{
			type: "person"
		}, {
			type: "department"
		}, {
			type: "radio",
			key: "job_status",
			children: [
				{id: "", 	text: "全部"},
				{id: "1", text: "在职"},
				{id: "5", text: "离职"},
			]
		}
	]

	tableColumn = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-4x'
		},{
			title: '中文名',
			dataIndex: 'employee_name',
			key: 'employee_name',
			className: 'table-global-head-6x'
		}, {
			title: '英文名',
			dataIndex: 'english_name',
			key: 'english_name',
			className: 'table-global-head-7x'
		}, {
			title: '部门名称',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head-7x'
		}, {
			title: '入职日期',
			dataIndex: 'entry_date',
			key: 'entry_date',
			className: 'table-global-head-6x'
		},
		//  {
		// 	title: '转正日期',
		// 	dataIndex: 'forward_date',
		// 	key: 'forward_date',
		// 	className: 'table-global-head-6x'
		// }, {
		// 	title: '试用期工资',
		// 	dataIndex: 'probation_salary',
		// 	key: 'probation_salary',
		// 	className: 'table-global-head-6x'
		// },
		{
			title: '当前工资',
			dataIndex: 'current_salary',
			key: 'current_salary',
			className: 'table-global-head-5x'
		}, {
			title: '当前基本工资',
			dataIndex: 'current_base_salary',
			key: 'current_base_salary',
			className: 'table-global-head-6x'
		},{
			title: '基本占比',
			dataIndex: 'base_percent',
			key: 'base_percent',
			className: 'table-global-head-6x',
			render: text => text ? Math.round(text*100)+'%' : ""
		},{
			title: '绩效占比',
			dataIndex: 'performance_percent',
			key: 'performance_percent',
			className: 'table-global-head-6x',
			render: text => text ? Math.round(text*100)+'%' : ""
		},{
			title: '当前岗位工资',
			dataIndex: 'current_post_salary',
			key: 'current_post_salary',
			className: 'table-global-head-6x'
		},{
			title: '基础保障工资',
			dataIndex: 'current_guarantee_salary',
			key: 'current_guarantee_salary',
			className: 'table-global-head-6x'
		},{
			title: '全勤奖',
			dataIndex: 'current_attendance_bonus',
			key: 'current_attendance_bonus',
			className: 'table-global-head-6x'
		},{
			title: '补贴',
			dataIndex: 'current_fixed_allowance',
			key: 'current_fixed_allowance',
			className: 'table-global-head-6x'
		},{
			title: '固定津贴',
			dataIndex: 'current_fixed_allowance2',
			key: 'current_fixed_allowance2',
			className: 'table-global-head-6x'
		},
		{
			title: '个税开始月份',
			dataIndex: 'tax_start_month',
			key: 'tax_start_month',
			className: 'table-global-head-6x'
		},
		{
			title: '是否参与提成计算',
			dataIndex: 'is_deduct',
			key: 'is_deduct',
			className: 'table-global-head-6x',
			render: text => text ? "是" : "否"
		},
		{
			title: '其他',
			dataIndex: 'tax_invoice',
			key: 'tax_invoice',
			className: 'table-global-head-6x'
		},
		{
			title: '子女教育支出',
			dataIndex: 'children_education',
			key: 'children_education',
			className: 'table-global-head-6x'
		},{
			title: '继续教育支出',
			dataIndex: 'adult_education',
			key: 'adult_education',
			className: 'table-global-head-6x'
		}, {
			title: '住房贷款利息支出',
			dataIndex: 'home_loan_interest',
			key: 'home_loan_interest',
			className: 'table-global-head-6x'
		},{
			title: '住房租金支出',
			dataIndex: 'housing_rents',
			key: 'housing_rents',
			className: 'table-global-head-6x'
		},{
			title: '赡养老人支出',
			dataIndex: 'support_the_old',
			key: 'support_the_old',
			className: 'table-global-head-6x'
		},{
			title: '专项总计',
			dataIndex: 'special_total',
			key: 'special_total',
			className: 'table-global-head-6x'
		}, {
			title: '操作',
			dataIndex: 'actions',
			key: 'actions',
			className: 'table-global-head-11x',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={this.childModuleName}
					access={this.props.access} />
			)
		}
	]

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "调整薪资",
			access: "u_value",
			click: this.updateData.bind(this, record,'', index)
		},{
			size: "small",
			type: "default",
			icon: "edit",
			title: "修改",
			access: "u_value",
			click: this.updateData.bind(this, record,'edit', index)
		}
		, {
			size: "small",
			type: "default",
			icon: "edit",
			title: "调薪记录",
			access: "u_value",
			click: this.selectRecord.bind(this, record.id)
		}
	]

	formColumn = [{
		label: "员工姓名",
		key: "employee_id",
		valueKey: "employee_name",
		type: "person",
		span: 24,
		valueWidth: "300px",
		valueWidthSelect: "276px",
		rules: {
			disabled:  null !== this.state.currentIndex
		}
	}, {
		label: "基本工资",
		key: "current_base_salary",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	}, {
		label: "基本占比",
		key: "base_percent",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, max:1, step: 0.01}
	}, {
		label: "绩效占比",
		key: "performance_percent",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, max:1, step: 0.01}
	}, {
		label: "岗位工资",
		key: "current_post_salary",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	},

	{
		label: "基础保障工资",
		key: "current_guarantee_salary",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	},
	{
		label: "全勤奖",
		key: "current_attendance_bonus",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	},
	{
		label: "补贴",
		key: "current_fixed_allowance",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	},
	{
		label: "固定津贴",
		key: "current_fixed_allowance2",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	},
	{
		label: "个税开始月份",
		key: "tax_start_month",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	},
	{
		label: "是否有提成",
		key: "is_deduct",
		type: "checkbox",
		span: 24,
		children: [
			{id: true, text: "是"},
			{id: false, text: "否"},
		],
		valueWidth:'300px'
	},
	{
		label: "其他",
		key: "tax_invoice",
		type: "number",
		span: 24,
		valueWidth: "300px",
		rules: {min: 0, step: 0.01}
	},
	{
		label: "子女教育支出",
		key: "children_education",
		type: "number",
		span: 24,
		valueWidth: "300px",
		required:false,
		rules: {min: 0, step: 0.01},
	}, {
		label: "继续教育支出",
		key: "adult_education",
		type: "number",
		span: 24,
		valueWidth: "300px",
		required:false,
		rules: {min: 0, step: 0.01},
	}, {
		label: "住房贷款利息支出",
		key: "home_loan_interest",
		type: "number",
		span: 24,
		valueWidth: "300px",
		required:false,
		rules: {min: 0, step: 0.01},
	}, {
		label: "住房租金支出",
		key: "housing_rents",
		type: "number",
		span: 24,
		valueWidth: "300px",
		required:false,
		rules: {min: 0, step: 0.01},
	}, {
		label: "赡养老人支出",
		key: "support_the_old",
		type: "number",
		span: 24,
		valueWidth: "300px",
		required:false,
		rules: {min: 0, step: 0.01},
	}, {
		label: "缴纳单位",
		key: "pay_unit",
		type: "select",
		span: 24,
		children: [
			{id: "上海长颈鹿投资有限公司", text: "上海长颈鹿投资有限公司"},
			{id: "上海徐汇区长颈鹿美语培训中心", text: "上海徐汇区长颈鹿美语培训中心"},
			{id: "上海长颈鹿培训学校有限公司", text: "上海长颈鹿培训学校有限公司"},
		],
		valueWidth:'300px'
	}
]

	recordHeaderColumn = [{
			title: "批量删除",
			icon: "delete",
			access: "delete_att_record_value",
			click: this.deleteRecord
		}
	]

	recordColumn = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: 'table-global-head-short'
		},{
			title: '中文名',
			dataIndex: 'employee_name',
			key: 'employee_name',
			className: 'table-global-head-short'
		}, {
			title: '英文名',
			dataIndex: 'english_name',
			key: 'english_name',
			className: 'table-global-head-short'
		}, {
			title: '部门名称',
			dataIndex: 'department_name',
			key: 'department_name',
			className: 'table-global-head'
		}, {
			title: '调整前基本工资',
			dataIndex: 'last_base_salary',
			key: 'last_base_salary',
			className: 'table-global-head'
		}, {
			title: '基本工资',
			dataIndex: 'current_base_salary',
			key: 'current_base_salary',
			className: 'table-global-head'
		}, {
			title: '调整前岗位工资',
			dataIndex: 'last_post_salary',
			key: 'last_post_salary',
			className: 'table-global-head'
		}, {
			title: '岗位工资',
			dataIndex: 'current_post_salary',
			key: 'current_post_salary',
			className: 'table-global-head'
		},
		//  {
		// 	title: '调整前其他',
		// 	dataIndex: 'last_tax_invoice',
		// 	key: 'last_tax_invoice',
		// 	className: 'table-global-head'
		// },
		//  {
		// 	title: '其他',
		// 	dataIndex: 'tax_invoice',
		// 	key: 'tax_invoice',
		// 	className: 'table-global-head'
		// },
		{
			title: '调整前补贴',
			dataIndex: 'last_current_fixed_allowance',
			key: 'last_current_fixed_allowance',
			className: 'table-global-head'
		},
		{
			title: '补贴',
			dataIndex: 'current_fixed_allowance',
			key: 'current_fixed_allowance',
			className: 'table-global-head'
		},{
			title: '调整前固定津贴',
			dataIndex: 'last_current_fixed_allowance2',
			key: 'last_current_fixed_allowance2',
			className: 'table-global-head'
		}, {
			title: '固定津贴',
			dataIndex: 'current_fixed_allowance2',
			key: 'current_fixed_allowance2',
			className: 'table-global-head'
		}, {
			title: '调整时间',
			dataIndex: 'adjust_time',
			key: 'adjust_time',
			className: 'table-global-head-short'
		}, {
			title: '调整原因',
			dataIndex: 'remark',
			key: 'remark',
			className: 'table-global-head-short'
		}, {
			title: '操作人',
			dataIndex: 'operate_user',
			key: 'operate_user',
			className: 'table-global-head-short'
		}, {
			title: '操作时间',
			dataIndex: 'operate_time',
			key: 'operate_time',
			className: 'table-global-head-short'
		}]

	customComponentWillMount () {
		this.props.fetchDepartmentsList();
	}

	updateData = (record,action, index) =>{
		this.setState({
			currentData: this.dataSource().data.Data[index],
			currentModalStatus: true,
			currentDataStatus: "loaded",
			currentIndex: index,
			action:action
		})
		if(action==''){
			//修改薪资
			this.formColumn = [{
				label: "员工姓名",
				key: "employee_id",
				valueKey: "employee_name",
				type: "person",
				span: 24,
				valueWidth: "300px",
				valueWidthSelect: "276px",
				rules: {
					disabled:  null !== this.state.currentIndex
				}
			}, {
				label: "基本工资",
				key: "current_base_salary",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			}, {
				label: "基本占比",
				key: "base_percent",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, max:1, step: 0.01}
			}, {
				label: "绩效占比",
				key: "performance_percent",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, max:1, step: 0.01}
			}, {
				label: "岗位工资",
				key: "current_post_salary",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},

			{
				label: "基础保障工资",
				key: "current_guarantee_salary",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "全勤奖",
				key: "current_attendance_bonus",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "补贴",
				key: "current_fixed_allowance",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "固定津贴",
				key: "current_fixed_allowance2",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			}, {
				label: "调整时间",
				key: "adjust_time",
				type: "date",
				span: 24,
				valueWidth: "300px",
				rules: {rows: 5},
				required:false,
				hide: null === this.state.currentIndex
			},{
				label: "调整原因",
				key: "remark",
				type: "textarea",
				span: 24,
				valueWidth: "300px",
				rules: {rows: 5},
				required:false,
				hide: null === this.state.currentIndex
			}
		]
		}else{
			this.formColumn=[{
				label: "员工姓名",
				key: "employee_id",
				valueKey: "employee_name",
				type: "person",
				span: 24,
				valueWidth: "300px",
				valueWidthSelect: "276px",
				rules: {
					disabled:  null !== this.state.currentIndex
				}
			}, {
				label: "基本工资",
				key: "current_base_salary",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},  {
				label: "基本占比",
				key: "base_percent",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, max:1, step: 0.01}
			}, {
				label: "绩效占比",
				key: "performance_percent",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, max:1, step: 0.01}
			},{
				label: "岗位工资",
				key: "current_post_salary",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},

			{
				label: "基础保障工资",
				key: "current_guarantee_salary",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "全勤奖",
				key: "current_attendance_bonus",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "补贴",
				key: "current_fixed_allowance",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "固定津贴",
				key: "current_fixed_allowance2",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "个税开始月份",
				key: "tax_start_month",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "是否有提成",
				key: "is_deduct",
				type: "checkbox",
				span: 24,
				children: [
					{id: true, text: "是"},
					{id: false, text: "否"},
				],
				valueWidth:'300px'
			},
			{
				label: "其他",
				key: "tax_invoice",
				type: "number",
				span: 24,
				valueWidth: "300px",
				rules: {min: 0, step: 0.01}
			},
			{
				label: "子女教育支出",
				key: "children_education",
				type: "number",
				span: 24,
				valueWidth: "300px",
				required:false,
				rules: {min: 0, step: 0.01},
			}, {
				label: "继续教育支出",
				key: "adult_education",
				type: "number",
				span: 24,
				valueWidth: "300px",
				required:false,
				rules: {min: 0, step: 0.01},
			}, {
				label: "住房贷款利息支出",
				key: "home_loan_interest",
				type: "number",
				span: 24,
				valueWidth: "300px",
				required:false,
				rules: {min: 0, step: 0.01},
			}, {
				label: "住房租金支出",
				key: "housing_rents",
				type: "number",
				span: 24,
				valueWidth: "300px",
				required:false,
				rules: {min: 0, step: 0.01},
			}, {
				label: "赡养老人支出",
				key: "support_the_old",
				type: "number",
				span: 24,
				valueWidth: "300px",
				required:false,
				rules: {min: 0, step: 0.01},
			}, {
				label: "缴纳单位",
				key: "pay_unit",
				type: "select",
				span: 24,
				children: [
					{id: "上海长颈鹿投资有限公司", text: "上海长颈鹿投资有限公司"},
					{id: "上海徐汇区长颈鹿美语培训中心", text: "上海徐汇区长颈鹿美语培训中心"},
					{id: "上海长颈鹿培训学校有限公司", text: "上海长颈鹿培训学校有限公司"},
				],
				valueWidth:'300px'
			}
		]
		}
	}

	createData = () => this.setState({
		currentData: {},
		currentModalStatus: true,
		currentDataStatus: "loaded",
		currentIndex: null
	})
	publicCreate = posts => {
		if ("function" === typeof this.actions.createAction) {
			this.actions.createAction(posts, res => {
				if (res.data.Success) {
					this.toggleCurrentModal();
					message.success("添加数据成功", 4);
					this.actions.changeAction();
				}else{
					if(res.data.Errors){
						message.error("添加数据失败 " + res.data.Errors[0], 4);
					}
					else{
						message.error("添加数据失败 " + res.data.Message, 4);
					}

				}
			}, err => message.error("添加数据失败, 请联系管理员", 4))
		}else{
			this.handleError("Child class's actions createAction is required!");
		}
	}

	publicUpdate = puts => {
		if ("function" === typeof this.actions.updateAction) {
			this.actions.updateAction(puts, this.state.currentIndex, res => {
				if (res.data.Success) {
					this.toggleCurrentModal();
					message.success("修改数据成功", 4);
					this.actions.changeAction({}, "reload")
				}else{
					if(res.data.Errors){
						message.error("修改数据失败 " + res.data.Errors[0], 4);
					}
					else{
						message.error("修改数据失败 " + res.data.Message, 4);
					}
				}
			}, err => message.error("修改数据失败, 请联系管理员", 4))
		}else{
			this.handleError("Child class's actions updateAction is required!");
		}
	}
	publicSubmit = () => this.props.form.validateFields((err, values) => {

		if (!err) {
			const submitData = {
				...this.state.currentData,
				...values,
				action:this.state.action
			}
			const callee = null === this.state.currentIndex ?
				this.publicCreate : this.publicUpdate;
			callee(submitData);
			// this.actions.changeAction({}, "reload")
		}else{
			console.log(err);
		}
	})

	selectRecord = id => this.setState({
		recordModalStatus: true,
		recordIndex: id,
		recordDataStatus: "unload",
	}, () => {
		const config = {
			title: "查看调薪记录",
			data: {staff_salary_management_id: id},
			callee: salaryManagementService.selectSalaryManagementRecord,
			callback: res => this.setState({
				recordData: res.data.Object,
				recordDataStatus: "loaded"
			})
		}
		this.publicHandle(config);
	})

	toggleRecordModal = () => this.setState({
		recordModalStatus: !this.state.recordModalStatus
	})

	recordRowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			let ids = selectedRows.map(row => row.id);
			this.setState({selectedRecordID: ids});
		}
	}

	deleteRecord = () => {
		if (!this.state.selectedRecordID || 0 === this.state.selectedRecordID.length) {
			message.error("请选择要删除的记录", 4);
			return;
		}
		let config = {
			title: "删除调薪记录",
			alert: true,
			data: {ids: this.state.selectedRecordID},
			callee: salaryManagementService.deleteSalaryRecord,
			callback: res => salaryManagementService.selectSalaryManagementRecord({
				staff_salary_management_id: this.state.recordIndex}, reLoadRes => {this.setState({
				recordData: reLoadRes.data.Object,
				selectedRecordID: []
			});
			this.actions.changeAction({}, "reload");
		}
			)
		}
		this.publicHandle(config);

	}

    togglePasswordModal = (text) => {
		commonService.checkSecondPassword({ Password : text }, (response) => {
			if (response.data.Success) {
				this.setState({
					passwordModalStatus: !this.state.passwordModalStatus
				})
			} else {
				message.error('密码错误', 4)
			}
		})
    }

	goBack = () => {
		this.props.history.goBack()
	}

	count = ()=>{
      let { time } = this.state
      let siv = setInterval(() => {
        this.setState({ time: (time--) }, () => {
          if (time <= -1) {
            clearInterval(siv)
            this.setState({ loading: false, time: 59 })
          }
        })
      }, 1000)
    }

    sendSms = (e) => {
	  e.preventDefault()
      commonService.sendSms({ mobile: '15921098897' }, (response) => {
        if (response.data.Success) {
          this.setState({ loading: true })
          if (this.state.time !== 0) {
            this.count()
          }
          message.success('发送成功')
        } else {
          message.error('发送失败')
        }
      })
    }

	render () {

		return (

			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={this.childModuleName}
						access={this.props.access} />
					<DynamicFilter column={this.filterColumn}
						departmentsList={this.props.departmentStructure.departmentsList}
						value={this.dataSource().filters}
						setFilter={this.actions.changeAction} />
				</div>
				<Modal width="800px"
					maskClosable={false}
					visible={this.state.currentModalStatus}
					title={null === this.state.currentIndex?"新增薪资":(this.state.action==""?"调整薪资":"修改薪资")}
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					<DynamicForm column={this.formColumn}
						form={this.props.form}
						selectEmployee={this.props.fetchEmployeesList}
						employees={this.props.employeeManagement.employeeList}
						loadStatus={this.state.currentDataStatus}
						dataSource={this.state.currentData} />
				</Modal>
				<Modal width="1200px"
					visible={this.state.recordModalStatus}
					title="薪水调整记录"
					destroyOnClose={true}
					onCancel={this.toggleRecordModal}
					onOk={this.toggleRecordModal}
					footer={<Button type="primary" onClick={this.toggleRecordModal}>确定</Button>} >
					<div className="app-module-header">
					<Button type="primary" icon="delete" onClick={this.deleteRecord}>批量删除</Button>
						{/* <DynamicButton column={this.recordHeaderColumn}
							module={this.childModuleName}
							access={this.props.access} /> */}
					</div>
					<DynamicTable column={this.recordColumn}
						dataStatus={this.state.recordDataStatus}
						dataSource={this.state.recordData.Data}
						pagination={false}
						rowSelection={this.recordRowSelection} />
				</Modal>
				<div>
					<DynamicImport visible={this.state.importModalStatus}
						toggleModal={this.toggleImportModal}
						downloadTemplate={this.actions.downloadTemplateAction}
						importFile={this.actions.importAction} />
				</div>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.actions.changeAction} />
				</div>
				<Modal width='300px'
					   visible={this.state.passwordModalStatus}
					   title="页面已锁定"
					   destroyOnClose={true}
					   onCancel={this.goBack}
					   footer={null}>
					<div className="app-module-header">
						<Form>
							<Form.Item>
								<Search
									placeholder="请输入二级密码"
									enterButton="确认"
									size="large"
									type="password"
									onSearch={text=>this.togglePasswordModal(text)}
								/>
							</Form.Item>
						</Form>
					</div>
				</Modal>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		salaryAllowance: state.salaryAllowance,
		employeeManagement: state.employeeManagement,
		departmentStructure: state.departmentStructure
	}
}

const mapDispatchToProps = {
	fetchEmployeesList,
	fetchDepartmentsList,
	changeSalaryManagement,
	selectSalaryManagement,
	updateSalaryManagement,
}

SalaryManagement = Form.create()(SalaryManagement);

SalaryManagement = connect(mapStateToProps, mapDispatchToProps)(SalaryManagement);

export default LayoutWrapper(SalaryManagement);





// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/SalaryManagement.js